import { useEffect, useRef, useState, type MutableRefObject } from 'react'

export function useRollout<T extends HTMLElement = HTMLElement>(options: any): [MutableRefObject<T | null>, boolean] {
  const ref = useRef<T>(null)
  const [inView, setInView] = useState(false)
  useEffect(() => {
    if (inView) return // 已进入过，则不再观察
    const el = ref.current
    if (!el || typeof IntersectionObserver === 'undefined') return
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setInView(true)
        observer.disconnect() // 停止观察
      }
    }, options)
    observer.observe(el)
    return () => observer.disconnect()
  }, [inView, options])
  return [ref, inView]
}
